import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from './Navigation/Breadcrumbs/Breadcrumb';
import LogChart from './Widgets/Admin/Logs';
import Panel from './UI/Panel/Panel';
import UserCount from './Widgets/Admin/UserCount';
import TenantCount from './Widgets/Admin/TenantCount';
import TenantActivityChart from './Widgets/Admin/TenantActivityChart';

export default function AdminLanding() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const screenDefs = useSelector(state => state.auth.screenDefs);
    const { t } = useTranslation('translation');

    useEffect(() => {
        const loadCrumbs = () => {
            const crumbs = [
                { path: 'active', label: t('welcome') + ', ' + user.name, screen: screenDefs.Home}
            ]
            dispatch({ type: 'SET_NAV_CRUMBS', payload: crumbs });
        }
        loadCrumbs();
    }, [dispatch, t, user, screenDefs]);

    return (
        <Box sx={{ 
            flexGrow: 1, 
            p: 3,
            // background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e7eb 100%)',
            minHeight: '100vh'
        }}>
            <Breadcrumbs />
            <Grid container spacing={3}>
                <Grid
                    size={{
                        xs: 12,
                        md: 9
                    }}>
                    <Panel sx={{ 
                        p: 3,
                        background: '#fff',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                        height: '100%'
                    }}>
                        <LogChart />
                    </Panel>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 3
                    }}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <TenantCount />
                        </Grid>
                        <Grid size={12}>
                            <UserCount />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Panel sx={{
                        p: 3,
                        background: '#fff',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
                    }}>
                        <TenantActivityChart />
                    </Panel>
                </Grid>
                {/* <Grid item xs={12} md={6}>
                    <Paper sx={{ 
                        p: 3,
                        background: '#fff',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-2px)'
                        }
                    }}>
                        <Typography variant="h5" component="h2" gutterBottom sx={{
                            color: '#1a237e',
                            fontWeight: 600,
                            mb: 3
                        }}>
                            {t('tenantManagement')}
                        </Typography>
                        <TenantList />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ 
                        p: 3,
                        background: '#fff',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-2px)'
                        }
                    }}>
                        <Typography variant="h5" component="h2" gutterBottom sx={{
                            color: '#1a237e',
                            fontWeight: 600,
                            mb: 3
                        }}>
                            {t('userManagement')}
                        </Typography>
                        <Typography variant="body1" sx={{
                            color: '#5c6bc0'
                        }}>
                            {t('userManagementDescription')}
                        </Typography>
                    </Paper>
                </Grid> */}
            </Grid>
        </Box>
    );
} 